import { ChevronDown } from 'lucide-react';
import {
  Button,
  ButtonGroup,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@repo/ui-web';

export function ButtonGroupShowcase() {
  return (
    <div className="space-y-4">
      <div className="space-y-3">
        <p className="text-sm font-semibold text-foreground">Primary</p>
        <ButtonGroup>
          <Button variant="outline" size="md">
            Left
          </Button>
          <Button variant="outline" size="md">
            Center
          </Button>
          <Button variant="outline" size="md">
            Right
          </Button>
        </ButtonGroup>
      </div>

      <div className="space-y-3">
        <p className="text-sm font-semibold text-foreground">Secondary</p>
        <ButtonGroup>
          <Button variant="secondary-outline" size="md">
            Day
          </Button>
          <Button variant="secondary-outline" size="md">
            Week
          </Button>
          <Button variant="secondary-outline" size="md">
            Month
          </Button>
        </ButtonGroup>
      </div>

      <div className="space-y-3">
        <p className="text-sm font-semibold text-foreground">Dropdown Menu</p>
        <ButtonGroup>
          <Button variant="outline" size="md">
            Follow
          </Button>
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <Button variant="outline" size="icon">
                <ChevronDown className="h-4 w-4" />
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end">
              <DropdownMenuItem>Subscribe</DropdownMenuItem>
              <DropdownMenuItem>Mute</DropdownMenuItem>
              <DropdownMenuItem>Block</DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        </ButtonGroup>
      </div>
    </div>
  );
}
